import {Collapse, Grid, IconButton, Typography} from "@mui/material";
import EnhancedAutocomplete from "../../../../../../../components/EnhancedAutocomplete";
import {MappingArrow} from "../../../../../../../utils/icons";
import React, {useEffect} from "react";
import {MappingHeader} from "../../advanced_supplier_import";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { tableRowSx, pageContentGap } from "../../../../../../../theme";
import type {ImportProfile} from "../../../../../types";

// region TypeScript Interfaces
interface ListInfo {
    Name: string;
    Options: string[];
}

interface ListMappingItemProps {
    list: ListInfo;
    profile: ImportProfile;
    setProfile: React.Dispatch<React.SetStateAction<ImportProfile>>;
    mappedListItemOptions: Record<string, string[]>;
    open?: boolean;
    key?: React.Key;
}
// endregion

export default function ListMappingItem(props: ListMappingItemProps) {
    const {list, profile, setProfile, mappedListItemOptions} = props;
    const [open, setOpen] = React.useState<boolean>(false);

    useEffect(() => {
        setOpen(props.open ?? false);
    }, [props.open, profile.ListMappings, list.Name, list.Options, mappedListItemOptions]);

    if(list.Options.length === 0) return null;
    return (
        <Grid key={props.key} item size={12} style={{borderBottom: "1px solid lightgray", margin: "6px 0"}}>
            <Grid container>
                <Grid container alignItems={"center"} style={{gap: pageContentGap}} item size={6}>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>

                    <MappingHeader>
                        {list.Name}
                    </MappingHeader>
                </Grid>

                <Grid item size={6}>
                </Grid>
            </Grid>
            <Collapse in={open} timeout="auto" unmountOnExit style={{width: "100%", display: "flex", gap: pageContentGap, flexDirection: "column"}}>
                {list.Options.map((item, index) => {
                    const mappedValue = (profile.ListMappings[list.Name] as any)?.[item] ?? "";
                    return (
                        <Grid container item style={{margin: "6px 0"}} size={12} sx={tableRowSx} key={index}>
                            <Grid container item size={6} justifyContent={"center"} alignItems={"center"}
                                  style={{gap: pageContentGap, paddingRight: "6px"}}>
                                <EnhancedAutocomplete
                                    containerStyle={{flex: 1}}
                                    value={mappedValue}
                                    notMultiple
                                    options={mappedListItemOptions[list.Name] ?? []}
                                    onChange={(e: unknown, value: unknown) => {
                                        setProfile((prevState) => ({
                                            ...prevState,
                                            ListMappings: {
                                                ...prevState.ListMappings,
                                                [list.Name]: {
                                                    ...(prevState.ListMappings[list.Name] as any),
                                                    [item]: value
                                                }
                                            }
                                        }));
                                    }}
                                />

                                <MappingArrow/>
                            </Grid>
                            <Grid container item size={6} alignItems={"center"}>
                                <Typography>
                                    {item}
                                </Typography>
                            </Grid>
                        </Grid>
                    );
                })}
            </Collapse>
        </Grid>
    );
}
